import { HomeUserAddress } from '../types/address';

const SLUserAddress = Mach.requireModule('SLUserAddress');
const SLABStrategy = Mach.requireModule('SLABStrategy');
const SLCompass = Mach.requireModule('SLCompass');

function homeSelectedUserAddress() {
  if (SLUserAddress?.homeSelectedUserAddress) {
    const address = SLUserAddress.homeSelectedUserAddress() as HomeUserAddress;
    return address;
  }
  return null;
}
// 首页地址信息更新
const updateHomeSelectedAddress = (address) => {
  SLUserAddress?.updateAddress?.(address);
};
// 首页地址信息删除
const delHomeSelectedAddress = (addressId) => {
  if (addressId) {
    SLUserAddress?.deleteAddress?.(addressId);
  }
};

function getAddressABStrategy() {
  let { region: compassRegion } = SLCompass.getCompassInfo();
  compassRegion = compassRegion ? compassRegion.toLowerCase() : '';
  if (compassRegion === 'hk') {
    return SLABStrategy?.getStrategy?.({
      sceneKey: 'HKhomepage_paymentpage_address_ABtest',
      groupKey: 'HKhomepage_paymentpage_address_ABtest_exp1',
    });
  } else {
    return SLABStrategy?.getStrategy?.({
      sceneKey: 'KSAhomepage_paymentpage_address_ABtest',
      groupKey: 'KSAhomepage_paymentpage_address_ABtest_exp1',
    });
  }
}

function hitAddressStrategyA() {
  const { expKey = '' } = getAddressABStrategy() || {};
  return expKey === 'A';
}

function hitAddressStrategyB() {
  const { expKey = '' } = getAddressABStrategy() || {};
  return expKey === 'B';
}

function hitAddressStrategy() {
  return hitAddressStrategyA() || hitAddressStrategyB();
}

export {
  homeSelectedUserAddress, updateHomeSelectedAddress, delHomeSelectedAddress, hitAddressStrategyA, hitAddressStrategyB, hitAddressStrategy
};
